<greco-fit-video-unlocks *ngIf="community" [community]="community"></greco-fit-video-unlocks>
